import * as yup from 'yup'

export const apiKeyValidation = yup.object().shape({
    name: yup.string().required('Name cannot be blank'),
    description: yup.string().nullable(),
})
